module.exports = __webpack_public_path__ + "img/de.e05da0b8.svg";